import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { data } from 'jquery';
import { Globals } from 'src/app/service/global';
import { MeetingService } from 'src/app/service/meeting.service';
import { AgendaEditDialogComponent } from '../agenda-edit-dialog/agenda-edit-dialog.component';

@Component({
  selector: 'app-agenda-notes-field',
  templateUrl: './agenda-notes-field.component.html',
  styleUrls: ['./agenda-notes-field.component.css']
})
export class AgendaNotesFieldComponent implements OnInit {
  notesList: any
  agendaList :any;
  agendaPresenterList: any =[];
  constructor(private meetingService: MeetingService, private matDialogRef: MatDialogRef<AgendaNotesFieldComponent>,private globals: Globals,  @Inject(MAT_DIALOG_DATA) data: any ) { 
    this.agendaList= data.e ;
    var reqJSON = {
      "meetingId": this.agendaList.meetingId,
      "agendaId": this.agendaList.agendaId
    };
    this.meetingService.fetchAgendaWithMinutes(reqJSON).subscribe((data: any) => {
 
      this.agendaList = data.body;
      if(data.body.agendaDesc != "" && data.body.agendaDesc != null && data.body.agendaDesc != undefined){
        this.agEditDiaolg.controls['agendaDesc'].setValue(data.body.agendaDesc);

      }
    });
    
 
    this.setData();
  }
  agEditDiaolg = new UntypedFormGroup({
    agendaTitle: new UntypedFormControl(''),
    agendaId: new UntypedFormControl(''),
    agendaDuration: new UntypedFormControl(''),
    agendaPresenterList: new UntypedFormControl(''),
    agendaDesc: new UntypedFormControl(''),
    userId: new UntypedFormControl(''),
    meetingId:new UntypedFormControl(''),
  });
  

  setData(){
    this.agendaList.agendaPresenterList.forEach((presenter: any) => {
      var presenterJsonList={
        "presenterUserId" : presenter.presenterUserId,
        "presenterName" : presenter.presenterName
      }
      this.agendaPresenterList.push(presenterJsonList);
      //

    });
    this.agEditDiaolg.controls['agendaTitle'].setValue(this.agendaList.agendaTitle);
    this.agEditDiaolg.controls['agendaId'].setValue(this.agendaList.agendaId);
    this.agEditDiaolg.controls['agendaDuration'].setValue(this.agendaList.agendaDuration);
    this.agEditDiaolg.controls['agendaPresenterList'].setValue(this.agendaPresenterList);
    this.agEditDiaolg.controls['agendaDesc'].setValue(this.agendaList.agendaDesc);
    this.agEditDiaolg.controls['userId'].setValue(this.globals.userId);
    this.agEditDiaolg.controls['meetingId'].setValue(this.agendaList.meetingId);

  }

 updateDesc(){
   //
   this.meetingService.updateModernAgenda(this.agEditDiaolg.value,this.agendaList.agendaId).subscribe((res: { body: any; }) => {
    var resp = res.body;
    //
  });
  this.matDialogRef.close();
 }


  ngOnInit(): void {
  }

}
